export default __webpack_public_path__ + "static/media/rusticLeaves.31f3dcf0.png";